import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Input, Select } from 'antd'
import { concat, filter, isEmpty, map, size } from 'lodash'
import './InspectionReportDrawer.style.less'
import { useEffect, useState } from 'react'
import { REPORT_CONTROL_TYPES } from '@/screens/QSF/InspectionReport/InSpectionReport.constant'
const { SELECT_DROPDOWN, TEXT } = REPORT_CONTROL_TYPES

function EditableChoiceListComponent(props: any) {
  const { dataSource = [] } = props

  // CASE FIRST FORM LOAD WITH UNDEFINED VALUE
  if (props.value === undefined) return

  const mapDataType: any = map(props.value, (item) => ({
    value: item,
    control_type: TEXT,
    status: '',
  }))

  const [stateData, setStateData] = useState<any>(mapDataType)
  const [isDisabledAddNewEntry, setIsDisabledAddNewEntry] = useState(false)

  const removeItemFN = (index) => {
    setStateData((preState) => {
      return filter(preState, (_, i) => i !== index)
    })
  }

  const optionSelectedFN = (value, index) => {
    if (value) {
      setStateData((preState) => {
        return map(preState, (item, i) =>
          i === index ? { value, control_type: TEXT } : item
        )
      })
    }
  }

  const inputChangeFN = (event, index) => {
    const isError = (v) => (v ? '' : 'error')
    setStateData((preState) => {
      return map(preState, (item, i) =>
        i === index
          ? {
              ...item,
              value: event.target.value,
              status: isError(event.target.value),
            }
          : item
      )
    })
  }

  useEffect(() => {
    if (isEmpty(stateData)) {
      onAddNewEntryFN()
    }
    const isNewEntry = filter(
      stateData,
      (item: any) => item.control_type === SELECT_DROPDOWN
    )
    setIsDisabledAddNewEntry(!!size(isNewEntry))
    handleOnChange(stateData)
  }, [stateData])

  const handleOnChange = (value) => {
    const mapResult = map(value, 'value')
    props.onChange(mapResult)
  }

  const onAddNewEntryFN = () => {
    setStateData((stateData) =>
      concat(stateData, {
        value: '',
        control_type: SELECT_DROPDOWN,
        status: '',
      })
    )
  }

  const renderItem = map(stateData, (item, index) => {
    if (item.control_type === SELECT_DROPDOWN) {
      return (
        <div className="wrap-checkpoints-form-item" key={index}>
          <Select
            className="editable-option"
            allowClear
            placeholder="Result"
            options={dataSource}
            onSelect={(value) => optionSelectedFN(value, index)}
            autoFocus
            defaultOpen={!isDisabledAddNewEntry}
            suffixIcon={null}
          />
          <Button
            type="text"
            className="button-delete"
            onClick={() => {
              removeItemFN(index)
            }}
            icon={
              <DeleteOutlined
                style={{
                  fontSize: '24px',
                  color: '#848484',
                }}
              />
            }
          />
        </div>
      )
    }

    return (
      <div className="wrap-checkpoints-form-item" key={index}>
        <div className="checkpoint-item">
          <Input
            size="large"
            onChange={(e) => inputChangeFN(e, index)}
            value={item.value}
          />
        </div>
        <Button
          type="text"
          className="button-delete"
          onClick={() => {
            removeItemFN(index)
          }}
          icon={
            <DeleteOutlined
              style={{
                fontSize: '24px',
                color: '#848484',
              }}
            />
          }
        />
      </div>
    )
  })

  return (
    <div>
      {renderItem}
      <Button
        color="primary"
        type="text"
        disabled={isDisabledAddNewEntry}
        onClick={onAddNewEntryFN}
        className="add-entry"
        icon={<PlusOutlined className="plus-icon" />}
      >
        Add Entry
      </Button>
    </div>
  )
}
export default EditableChoiceListComponent
